"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _react2 = require("@emotion/react");

var _uuid = require("uuid");

var _propTypes = require("prop-types");

var _groove = _interopRequireDefault(require("../../theme/groove"));

var _Toast = _interopRequireDefault(require("./Toast"));

var _Toast2 = require("./Toast.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Some of the code in this file are from rc-notification:
// https://github.com/react-component/notification/blob/master/src/Notification.tsx
// The reason for not using the package directly:
// 1. can't wrap motion (from framer-motion) to each toast to provide nice animation
// 2. there is no progess indicator
var ToastContainer = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var maxCount = _ref.maxCount,
      theme = _ref.theme;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1]; // Add or update a toast


  var add = (0, _react.useCallback)(function (originToast) {
    var key = originToast.key || (0, _uuid.v4)();

    var toast = _objectSpread(_objectSpread({}, originToast), {}, {
      key: key
    });

    setToasts(function (previousToasts) {
      var toastIndex = previousToasts.findIndex(function (t) {
        return t.key === key;
      });
      var updatedNotices = (0, _toConsumableArray2["default"])(previousToasts);

      if (toastIndex !== -1) {
        // Update the toast if it exists
        updatedNotices.splice(toastIndex, 1, toast);
      } else {
        // Add the new toast
        // if the number is over the maxCount, remove the first one first
        if (maxCount && previousToasts.length >= maxCount) {
          updatedNotices.shift();
        }

        updatedNotices.push(toast);
      }

      return updatedNotices;
    });
  }, [maxCount]); // Remove a toast with key

  var remove = (0, _react.useCallback)(function (removeKey) {
    setToasts(function (previousToasts) {
      return previousToasts.filter(function (_ref2) {
        var key = _ref2.key,
            userPassKey = _ref2.userPassKey;
        var mergedKey = userPassKey || key;
        return mergedKey !== removeKey;
      });
    });
  }, []);
  var getRef = (0, _react.useCallback)(function (element) {
    ref(element, {
      add: add,
      remove: remove
    });
  }, [add, ref, remove]);
  return (// We need to render toasts outside of the root div,
    // so we can't access theme unless we wrap the container with ThemeProvider to pass theme
    (0, _jsxRuntime.jsx)(_react2.ThemeProvider, {
      theme: theme,
      children: (0, _jsxRuntime.jsx)("div", {
        ref: getRef,
        css: _Toast2.styles.container,
        children: (0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
          children: toasts.map(function (_ref3) {
            var key = _ref3.key,
                content = _ref3.content,
                otherProps = (0, _objectWithoutProperties2["default"])(_ref3, ["key", "content"]);
            return (0, _jsxRuntime.jsx)(_Toast["default"], _objectSpread(_objectSpread({
              noticeKey: key,
              onClose: remove
            }, otherProps), {}, {
              children: content
            }), key);
          })
        })
      })
    })
  );
});
ToastContainer.propTypes = {
  /**
   * Maximum number of toasts
   */
  maxCount: _propTypes.number,

  /**
   * Project theme
   */
  theme: (0, _propTypes.shape)({
    color: (0, _propTypes.shape)({
      monochrome: (0, _propTypes.shape)({}),
      primary: (0, _propTypes.shape)({}),
      secondary: (0, _propTypes.shape)({})
    }),
    fontWeight: (0, _propTypes.shape)({}),
    spacing: (0, _propTypes.shape)({})
  })
};
ToastContainer.defaultProps = {
  maxCount: undefined,
  theme: _groove["default"].light
};
ToastContainer.displayName = 'ToastContainer';
var _default = ToastContainer;
exports["default"] = _default;
//# sourceMappingURL=ToastContainer.js.map